module.exports = __webpack_public_path__ + "static/img/icon2.66cf695.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon2.jpg
// module id = eRKk
// module chunks = 0